// Cart Auto-Add
(() => {
  let pending = false;

  window.addEventListener('abra:cart:changed', function() {
    if (pending) return;

    pending = true;

    setTimeout(function() {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));

      setTimeout(function() {
        pending = false;
      }, 1000);
    }, 50);
  });
})();

// Dynamically injects data-variant-id and data-product-handle into the quick view modal's elements
(() => {
  let debounceTimer = null;

  function updatePriceAttributes() {
    const productInfo = document.querySelector('product-info[data-view-mode="quick-view"]');
    if (!productInfo) return;

    const handle = productInfo.dataset.productHandle;
    const variantJson = productInfo.querySelector('script[data-selected-variant]');
    const priceBlock = productInfo.querySelector('.m-price');

    let variantId = null;
    if (variantJson) {
      try {
        variantId = JSON.parse(variantJson.textContent).id;
      } catch (e) {}
    }

    if (variantId) {
      productInfo.setAttribute('data-variant-id', variantId);
    }

    if (priceBlock) {
      if (handle) priceBlock.setAttribute('data-product-handle', handle);
      if (variantId) priceBlock.setAttribute('data-variant-id', variantId);
    }
  }

  const observer = new MutationObserver(() => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(updatePriceAttributes, 150);
  });

  observer.observe(document.body, { childList: true, subtree: true });

  updatePriceAttributes();
})();